import { useLingui } from '@lingui/react/macro'

import * as Form from '@/features/form'
import { FileUpload, PRESETS } from '@/features/files'
import Title from './Title'
import InputTile from './InputTile'
import { FormData } from '../hooks/useBranding'

export default function Logo() {
  const { t } = useLingui()

  return (
    <InputTile>
      <Title
        title={t`Logo`}
        description={t`Your Logo, you have to crop it to a square after selecting it, so that we can use it in browsers as Favicon.`}
      />
      <Form.Data<FormData>>
        {({ colors: { navBackground } }) => (
          <Form.Field
            name="logo"
            rules={{
              required: t`This field is required`
            }}
          >
            {({ renderProps }) => (
              <FileUpload
                className="max-h-48 w-48"
                objectFit="cover"
                backgroundColor={navBackground}
                accept="image/*"
                placeholder={t`Choose a Logo`}
                crop={{
                  aspectRatio: 1,
                  allowPadding: true,
                  shape: 'rect'
                }}
                imageResize={PRESETS.LOGO}
                {...renderProps}
              />
            )}
          </Form.Field>
        )}
      </Form.Data>
    </InputTile>
  )
}
